import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cafcf83c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=cafcf83c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafcf83c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cafcf83c')) {
      api.createRecord('cafcf83c', component.options)
    } else {
      api.reload('cafcf83c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cafcf83c&scoped=true", function () {
      api.rerender('cafcf83c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/automaticSortings/manualSorting/index.vue"
export default component.exports